import { useFormContext, useWatch } from "react-hook-form"

import { FormChipGroup } from "@/components/form-elements/FormChipGroup"
import { FormMoneyInput } from "@/components/form-elements/FormMoneyInput"
import {
  EMPTY_AMOUNT,
  type FundReadyIntakeFormValues,
} from "@/lib/fundready/schema"

const POSITION_OPTIONS = [
  { value: 0, label: "None" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4 or more" },
]

export function StepDebt() {
  const form = useFormContext<FundReadyIntakeFormValues>()
  const positions = useWatch({ control: form.control, name: "positions" })

  return (
    <>
      <FormChipGroup<FundReadyIntakeFormValues, number>
        name="positions"
        label="Open funding positions (loans, MCAs, lines currently being repaid)"
        options={POSITION_OPTIONS}
        onChange={(value) => {
          // 0 while no positions (submit-ready), blank once positions reappear
          // so the input prompts for a real figure instead of a stale 0.
          if (value === 0) {
            form.setValue("monthlyDebt", 0)
          } else if (positions === 0) {
            form.setValue("monthlyDebt", EMPTY_AMOUNT)
          }
        }}
      />
      {positions > 0 && (
        <FormMoneyInput<FundReadyIntakeFormValues>
          name="monthlyDebt"
          label="Total monthly debt payments (all positions combined)"
          placeholder="$6,500"
        />
      )}
    </>
  )
}
